module.exports = __webpack_public_path__ + "img/operationCapacity10.df090725.png";